import { MENSAGENS, getDataFormatada, validarData, verificarDatas, } from '../../../../../utils';
export var getErroDataNascimento = function (dataNascimento, dataAtual) {
    if (dataAtual === void 0) { dataAtual = new Date(); }
    if (!dataNascimento || dataNascimento.trim() == '') {
        return "Data de Nascimento ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO);
    }
    if (!validarData(dataNascimento)) {
        return "Data de Nascimento ".concat(MENSAGENS.PREENCHIMENTO_INVALIDO);
    }
    var dataAtualFormatada = getDataFormatada(dataAtual.toISOString().split('T')[0]);
    if (!verificarDatas(dataNascimento, dataAtualFormatada, true)) {
        return "Data de Nascimento ".concat(MENSAGENS.DATA_MAIOR_DATA_ATUAL);
    }
    return null;
};
